import { APP_ROUTES } from "helpers/routeHelpers"

import dashboardIcon from "../../assets/images/icons/dashboard-icon.svg"
import locationIcon from "../../assets/images/icons/ad-location-icon.svg"
import adminInvreq from "../../assets/images/icons/ad-inventory-request.svg"
import adminUserMang from "../../assets/images/icons/ad-user-management.svg"
import invMangIcon from "../../assets/images/icons/inventory-management-icon.svg"
import orderMangIcon from "../../assets/images/icons/order-management-icon.svg"
import venMangIcon from "../../assets/images/icons/vendor-management-icon.svg"
import settingsIcon from "../../assets/images/icons/wh-sd-settings-icon-wt.svg"
import trailerMngIcon from "../../assets/images/icons/trailer-management-icon.svg"
import productionLineIcon from "../../assets/images/icons/production-line-icon.svg"
import timelineIcon from "../../assets/images/icons/timeline-icons.png"
import countsheetIcon from "../../assets/images/icons/countsheet-icon.svg"
import baseFeaturesIcon from "../../assets/images/icons/base-features-icon.svg"
import packagesIcon from "../../assets/images/icons/packages-icon.svg"
import customizationIcon from "../../assets/images/icons/customization-icon.svg"
import equipmentIcon from "../../assets/images/icons/equipment-icon.svg"
import warrantyIcon from "../../assets/images/icons/warranty-icon.svg"

import { UserRoles } from "../../constants"

const {
   Finance,
   Executive,
   SuperAdmin,
   Admin,
   PlantManager,
   AssistantPlantManager,
   FrontOffice,
} = UserRoles

export const roleBasedSequence = {
   [PlantManager]: {
      [APP_ROUTES.TIMELINE]: 1,
      [APP_ROUTES.INVENTORY_MANAGEMENT]: 2,
      [APP_ROUTES.COUNT_SHEET]: 3,
      [APP_ROUTES.USER_MANAGEMENT]: 4,
   },
   [AssistantPlantManager]: {
      [APP_ROUTES.TIMELINE]: 1,
      [APP_ROUTES.INVENTORY_MANAGEMENT]: 2,
      [APP_ROUTES.COUNT_SHEET]: 3,
   },
   [FrontOffice]: {
      [APP_ROUTES.ORDER_MANAGEMENT]: 1,
      [APP_ROUTES.TRAILERS_MANAGEMENT]: 2,
      [APP_ROUTES.TIMELINE]: 3,
      [APP_ROUTES.PRODUCTION_LINE_MANAGEMENT]: 4,
      [APP_ROUTES.CONFIGURATOR_TRAILERS]: 5,
   },
}

export const sideBarContent = [
   {
      routeName: APP_ROUTES.DASHBOARD,
      title: "Dashboard",
      image: dashboardIcon,
      imageClasses: "",
      titleClasses: "",
      routeClasses: "",
      liClasses: "",
      permissions: [Finance, Executive, SuperAdmin],
   },
   {
      routeName: APP_ROUTES.LOCATION,
      title: "Locations",
      image: locationIcon,
      imageClasses: "",
      titleClasses: "",
      routeClasses: "",
      liClasses: "",
      permissions: [Executive, SuperAdmin],
   },

   {
      routeName: APP_ROUTES.INVENTORY_REQUEST,
      title: "Inventory Requests",
      image: adminInvreq,
      imageClasses: "",
      titleClasses: "",
      routeClasses: "",
      liClasses: "",
      permissions: [Executive, SuperAdmin],
   },
   {
      routeName: APP_ROUTES.INVENTORY_MANAGEMENT,
      title: "Inventory Management",
      image: invMangIcon,
      imageClasses: "",
      titleClasses: "",
      routeClasses: "",
      liClasses: "",
      permissions: [
         Finance,
         Executive,
         SuperAdmin,
         PlantManager,
         AssistantPlantManager,
      ],
   },
   {
      routeName: APP_ROUTES.ORDER_MANAGEMENT,
      title: " Order Management",
      image: orderMangIcon,
      imageClasses: "",
      titleClasses: "",
      routeClasses: "",
      liClasses: "",
      permissions: [Finance, Executive, SuperAdmin, FrontOffice],
   },
   {
      routeName: APP_ROUTES.USER_MANAGEMENT,
      title: " User Management",
      image: adminUserMang,
      imageClasses: "",
      titleClasses: "",
      routeClasses: "",
      liClasses: "",
      permissions: [SuperAdmin, PlantManager],
   },

   {
      routeName: APP_ROUTES.VENDOR_MANAGEMENT,
      title: " Vendor Management",
      image: venMangIcon,
      imageClasses: "",
      titleClasses: "",
      routeClasses: "",
      liClasses: "",
      permissions: [Finance, Executive, SuperAdmin],
   },

   {
      routeName: APP_ROUTES.CONFIGURATOR_TRAILERS,
      title: "Configurator Settings",
      image: settingsIcon,
      imageClasses: "settings-main-icon",
      titleClasses: "",
      routeClasses: "",
      liClasses: "",
      permissions: [SuperAdmin],
      hasSubmenu: true,
      submenuItems: [
         {
            routeName:
               APP_ROUTES.CONFIGURATOR_TRAILER_SETTINGS_GLOBAL_BASE_FEATURES,
            title: "Base Features",
            image: baseFeaturesIcon,
            imageClasses: "",
            titleClasses: "",
            routeClasses: "",
            liClasses: "",
            permissions: [SuperAdmin],
         },
         {
            routeName:
               APP_ROUTES.CONFIGURATOR_TRAILER_SETTINGS_GLOBAL_CUSTOMIZATION,
            title: "Personalization",
            image: packagesIcon,
            imageClasses: "",
            titleClasses: "",
            routeClasses: "",
            liClasses: "",
            permissions: [SuperAdmin],
         },
         {
            routeName: APP_ROUTES.CONFIGURATOR_TRAILER_SETTINGS_GLOBAL_PACKAGES,
            title: "Packages",
            image: customizationIcon,
            imageClasses: "",
            titleClasses: "",
            routeClasses: "",
            liClasses: "",
            permissions: [SuperAdmin],
         },
         {
            routeName:
               APP_ROUTES.CONFIGURATOR_TRAILER_SETTINGS_GLOBAL_EQUIPMENTS,
            title: "Equipment",
            image: equipmentIcon,
            imageClasses: "",
            titleClasses: "",
            routeClasses: "",
            liClasses: "",
            permissions: [SuperAdmin],
         },
         {
            routeName: APP_ROUTES.CONFIGURATOR_TRAILER_SETTINGS_GLOBAL_WARRANTY,
            title: "Warranty",
            image: warrantyIcon,
            imageClasses: "",
            titleClasses: "",
            routeClasses: "",
            liClasses: "",
            permissions: [SuperAdmin],
         },
      ],
   },
   {
      routeName: APP_ROUTES.TRAILERS_MANAGEMENT,
      title: " Trailer  Management",
      image: trailerMngIcon,
      imageClasses: "",
      titleClasses: "",
      routeClasses: "",
      liClasses: "",
      permissions: [SuperAdmin, FrontOffice],
   },
   {
      routeName: APP_ROUTES.TIMELINE,
      title: "Timeline",
      image: timelineIcon,
      imageClasses: "",
      titleClasses: "",
      routeClasses: "",
      liClasses: "",
      permissions: [
         Finance,
         Executive,
         SuperAdmin,
         PlantManager,
         AssistantPlantManager,
         FrontOffice,
      ],
   },
   {
      routeName: APP_ROUTES.PRODUCTION_LINE_MANAGEMENT,
      title: " Production Line",
      image: productionLineIcon,
      imageClasses: "",
      titleClasses: "",
      routeClasses: "",
      liClasses: "",
      permissions: [SuperAdmin, FrontOffice],
   },
   {
      routeName: APP_ROUTES.COUNT_SHEET,
      title: "Countsheets",
      image: countsheetIcon,
      imageClasses: "",
      titleClasses: "",
      routeClasses: "",
      liClasses: "",
      permissions: [
         Executive,
         SuperAdmin,
         PlantManager,
         AssistantPlantManager,
         Finance,
      ],
   },

   {
      routeName: APP_ROUTES.SETTINGS,
      title: " Settings",
      image: settingsIcon,
      imageClasses: "",
      titleClasses: "",
      routeClasses: "",
      liClasses: "",
      permissions: [Finance, Executive, SuperAdmin],
   },

   // {
   //   routeName: APP_ROUTES.FAQS,
   //   title: "FAQ'S",
   //   image: quesCircleIcon,
   //   imageClasses: "",
   //   titleClasses: "",
   //   routeClasses: "",
   //   liClasses: "",
   // },
]
